import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { brussels } from "../../data/brussels.utils";

//import { addView } from "../../actions/postActions";

const Neigbourhoods = (props) => {
  const { post } = props;

  function textEllipsis(
    str,
    maxLength,
    { side = "end", ellipsis = "..." } = {}
  ) {
    if (str.length > maxLength) {
      switch (side) {
        case "start":
          return ellipsis + str.slice(-(maxLength - ellipsis.length));
        case "end":
        default:
          return str.slice(0, maxLength - ellipsis.length) + ellipsis;
      }
    }
    return str;
  }

  const person = { last: "svekis", num: "001" };
  console.log("val_person", person);
  console.log("val_brussels", brussels);

  return (
    <div className="container mt-0" style={{ paddingTop: "0px" }}>
      <p className="text-left text-white">
        <small>
          <em> {textEllipsis(post.job_title, 25)}</em>{" "}
          <span className="badge bg-white text-dark"> in</span>
        </small>

        <span className="badge badge-sm-small badge-pill bg-info text-white badge-outline-info">
          {post.level}

          <Link to={`/post/${post._id}`}>
            {" "}
            <i className="fa fa-link text-white" />
          </Link>
        </span>
      </p>
    </div>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {})(Neigbourhoods);
